import React, { useState } from 'react';
import { Button, Col, Form, Input, Row, } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import I18N from 'src/services/I18NService';
import { BookKeepingSearchParam } from 'src/entity/BookKeepingEntity';


interface IProps extends FormComponentProps<{}> {
  defaultQuery: Partial<BookKeepingSearchParam>,
  loading: boolean,
  onSearch: (query: Partial<BookKeepingSearchParam>) => void,
}

const BookKeepingSearchComp: React.FC<IProps> = (props) => {
  const { defaultQuery, loading, form, onSearch } = props;
  const { getFieldDecorator } = form;

  const [queryParam, setQueryParam] = useState(defaultQuery);

  const handleSearch = () => {
    const {name, admin_name, admin_mobile} = form.getFieldsValue();
    // 将表单输入项 => 接口需要的类型
    const query: Partial<BookKeepingSearchParam> = {
      name,
      admin_name,
      admin_mobile,
    };
    onSearch(query);
  }

  const handleReset = () => {
    const result = new BookKeepingSearchParam();
    setQueryParam(result);
    form.resetFields();
  }


  return (
    <Form className="mdd-search-form">
      <Row gutter={20} type="flex" align="middle" >
        <Col span={5}>
          <Form.Item label={I18N.get('common_name_desc')} style={{marginBottom: 0}}>
            {getFieldDecorator('name', {
              initialValue: queryParam.name,
            })(
              <Input
                autoComplete="off"
                placeholder={`${I18N.get('common_input')}${I18N.get('common_name_desc')}`}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item label={I18N.get('common_admin')} style={{marginBottom: 0}}>
            {getFieldDecorator('admin_name', {
              initialValue: queryParam.admin_name,
            })(
              <Input
                autoComplete="off"
                placeholder={`${I18N.get('common_input')}${I18N.get('common_admin')}`}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item label={I18N.get('common_mobile')} style={{marginBottom: 0}}>
            {getFieldDecorator('admin_mobile', {
              initialValue: queryParam.admin_mobile,
            })(
              <Input
                autoComplete="off"
                placeholder={`${I18N.get('common_input')}${I18N.get('common_mobile')}`}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={5}>
          <Button
            type="primary"
            onClick={handleSearch}
            loading={loading}
          >{I18N.get('common_search')}</Button>
          <Button
            onClick={handleReset}
            style={{marginLeft: 16}}
          >{I18N.get('common_clear')}</Button>
        </Col>
      </Row>
    </Form>
    
  )
}
const WrappedBookKeepingSearchComp = Form.create<IProps>()(BookKeepingSearchComp)
const BookKeepingSearch = React.memo(WrappedBookKeepingSearchComp);
export default BookKeepingSearch;


// WEBPACK FOOTER //
// ./src/components/views/BookKeeping/BookKeepingSearch.tsx